<template>
  <div id="dashboard">
    <v-container fluid>
      <v-row align="center" class="mx-1">
          <div class="my-2">
            <v-btn
              depressed
              large
              rounded
              color="primary white--text"
              to="/personal"
              >Anterior</v-btn
            >
          </div>
        <v-spacer></v-spacer>
          <div class="my-2">
            <v-btn
              depressed
              large
              rounded
              color="primary white--text"
              to="/timeline"
              >Siguiente</v-btn
            >
          </div>
      </v-row>
      <v-row justify="center">
        <v-col class="d-flex child-flex" sm="12" md="4" lg="4"
        >
          <v-card class="mx-auto" color="#F5F5F5">
            <v-img
              :src="'images/fondos/habilidades.jpg'"
              :lazy-src="'images/fondos/habilidades.jpg'"
            ></v-img>

            <v-card-title>Habilidades</v-card-title>

            <v-card-actions>
              <v-btn color="#F4511E" text @click="habilidades = !habilidades">
                Más
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn icon @click="habilidades = !habilidades">
                <v-icon>{{
                  habilidades ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="habilidades">
                <v-divider></v-divider>

                <v-card-text>
                  <ul>
                    <li>Analítico</li>
                    <li>Sistemático</li>
                    <li>Creativo</li>
                    <li>Autodidacta</li>
                    <li>Resiliente</li>
                    <li>Poder de Negociación</li>
                    <li>Trabajo bajo presión</li>
                  </ul>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
        <v-col class="d-flex child-flex" sm="12" md="4" lg="4">
          <v-card class="mx-auto" color="#F5F5F5">
            <v-img
              :src="'images/fondos/objetivos.jpg'"
              :lazy-src="'images/fondos/objetivos.jpg'"
            ></v-img>

            <v-card-title>Objetivos</v-card-title>

            <v-card-actions>
              <v-btn color="#F4511E" text @click="objetivos = !objetivos">
                Más
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn icon @click="objetivos = !objetivos">
                <v-icon>{{
                  objetivos ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="objetivos">
                <v-divider></v-divider>

                <v-card-text>
                  <ul>
                    <li class="justify">
                      Continuar mi crecimiento como empresario y colocar a mis empresas con presencia a nivel nacional, ofreciendo proyecto de Desarrollo a la Medida y productos tecnológicos de la más alta calidad y funcionalidad para la vida diaria de las empresas de México.
                    </li>
                    <li class="justify">
                      Llevar a mis empresas más allá de las fronteras y en un plazo no mayor a 3 años.
                    </li>
                    <li class="justify">
                      Crear una nueva empresa de prototipos tecnológicos.
                    </li>
                  </ul>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center">
        
        <v-col class="d-flex child-flex" sm="12" md="4" lg="4">
          <v-card class="mx-auto" color="#F5F5F5">
            <v-img
              :src="'images/fondos/red.png'"
              :lazy-src="'images/fondos/red.png'"
            ></v-img>

            <v-card-title>Redes</v-card-title>

            <v-card-actions>
              <v-btn color="#F4511E" text @click="redes = !redes">
                Más
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn icon @click="redes = !redes">
                <v-icon>{{
                  redes ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="redes">
                <v-divider></v-divider>

                <v-card-text>
                  <ul>
                    <li class="justify">
                      Familia, formada por profesionistas.  
                    </li>
                    <li class="justify">
                    Red de amigos del sector Financiero Mexicano, más de 15 profesionales en distintas áreas con reuniones para convivir por lo menos 1 ves al mes.
                    </li>
                  </ul>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center">
        
        <v-col class="d-flex child-flex" sm="12" md="4" lg="4">
          <v-card class="mx-auto" color="#F5F5F5">
            <v-img
              :src="'images/fondos/logros.png'"
              :lazy-src="'images/fondos/logros.png'"
            ></v-img>

            <v-card-title>Logros</v-card-title>

            <v-card-actions>
              <v-btn color="#F4511E" text @click="logros = !logros">
                Más
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn icon @click="logros = !logros">
                <v-icon>{{
                  logros ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="logros">
                <v-divider></v-divider>

                <v-card-text>
                  <ul>
                    <li>
                    Participar en la creación de uno de los primeros nodos de internet en México en el año 1990 a 1992 NovaNet.
                    </li>
                    <li>Certificación de PMI</li>
                    <li>Creador del Producto Bo´ol.</li>
                    <li>
                      Cocreador del Producto Dharma con mi socio y amigo
                      JUCARIPO.
                    </li>
                  </ul>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
        <v-col class="d-flex child-flex" sm="12" md="4" lg="4">
          <v-card class="mx-auto" color="#F5F5F5">
            <v-img
              :src="'images/fondos/intereses.jpg'"
              :lazy-src="'images/fondos/intereses.jpg'"
            ></v-img>

            <v-card-title>Interés</v-card-title>

            <v-card-actions>
              <v-btn color="#F4511E" text @click="interes = !interes">
                Más
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn icon @click="interes = !interes">
                <v-icon>{{
                  interes ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="interes">
                <v-divider></v-divider>

                <v-card-text>
                  <ul>
                    <li>Generar alianzas de negocio sólidas.</li>
                    <li>Consolidar nuevos socios de negocios. </li>
                    <li>Acrecentar mi conocimiento en nuevas tecnologías.</li>
                  </ul>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import pageFooter from "@/components/Footer.vue";
import header from "@/components/header.vue";
export default {
  components: {
    pageFooter,
  },
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: "N°",
          align: "center",
          value: "id",
        },
        {
          text: "Nombre de Puesto",
          align: "center",
          value: "nombrePuesto",
        },
        {
          text: "Editar  /   Ver  / Eliminar",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      tab: null,
      text: "inin",
      align: ["start", "end", "center", "baseline", "stretch"],
      objetivos: false,
      habilidades: false,
      logros: false,
      interes: false,
      esfera: false,
      metas: false,
      redes:false
    };
  },
  methods: {},
  created() {},
};
</script>
